import { render } from "./ActivitiesHeader.vue?vue&type=template&id=dce14484&scoped=true"
import script from "./ActivitiesHeader.vue?vue&type=script&lang=js"
export * from "./ActivitiesHeader.vue?vue&type=script&lang=js"

import "./ActivitiesHeader.vue?vue&type=style&index=0&id=dce14484&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dce14484"]])

export default __exports__